import { createSlice } from "@reduxjs/toolkit";
import {
  downloadTopSoldProducts,
  getTopSoldProductsDetails,
  getTopSoldProductsInsights,
  getTopSoldProductsInsightsCustomers,
  getTopSoldProductsInsightsBreakdowns,
  getTopSoldProductsInsightsDaily,
  getTopSoldProductsInsightsSizes,
  getTopSoldProductsRanking,
  getTopSoldProductsShare,
} from "./topSoldProductsV3Action";

const section = (data) => ({
  loading: false,
  error: null,
  data,
  latestRequestId: null,
});

const initialState = {
  ranking: section({ results: [], total_products: 0 }),
  share: section({ results: [], total: null, total_products: 0 }),
  details: section({ results: [], meta: null }),
  insights: section(null),
  insightsDaily: section(null),
  insightsSizes: section(null),
  insightsBreakdowns: section(null),
  insightsCustomers: section(null),
  download: { loading: false, error: null },
};

// Filters change faster than the sections answer: only the latest request of
// a section may write to it.
const addSectionCases = (builder, thunk, key) =>
  builder
    .addCase(thunk.pending, (state, action) => {
      state[key].loading = true;
      state[key].error = null;
      state[key].latestRequestId = action.meta.requestId;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      if (action.meta.requestId !== state[key].latestRequestId) return;
      state[key].loading = false;
      state[key].data = action.payload;
    })
    .addCase(thunk.rejected, (state, action) => {
      if (action.meta.requestId !== state[key].latestRequestId) return;
      state[key].loading = false;
      state[key].data = initialState[key].data;
      state[key].error = action.payload;
    });

const topSoldProductsV3 = createSlice({
  name: "topSoldProductsV3",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addSectionCases(builder, getTopSoldProductsRanking, "ranking");
    addSectionCases(builder, getTopSoldProductsShare, "share");
    addSectionCases(builder, getTopSoldProductsDetails, "details");
    addSectionCases(builder, getTopSoldProductsInsights, "insights");
    addSectionCases(builder, getTopSoldProductsInsightsDaily, "insightsDaily");
    addSectionCases(builder, getTopSoldProductsInsightsSizes, "insightsSizes");
    addSectionCases(
      builder,
      getTopSoldProductsInsightsBreakdowns,
      "insightsBreakdowns"
    );
    addSectionCases(
      builder,
      getTopSoldProductsInsightsCustomers,
      "insightsCustomers"
    );
    builder
      .addCase(downloadTopSoldProducts.pending, (state) => {
        state.download.loading = true;
        state.download.error = null;
      })
      .addCase(downloadTopSoldProducts.fulfilled, (state) => {
        state.download.loading = false;
      })
      .addCase(downloadTopSoldProducts.rejected, (state, action) => {
        state.download.loading = false;
        state.download.error = action.payload;
      });
  },
});

export default topSoldProductsV3.reducer;
